module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.1025a6e0.ttf";